import OptionSplitsTable from "./OptionSplitsTable";
import { useGetOptionSplits } from "../../queries/optionSplit";

export function OptionSplit() {
  const { data } = useGetOptionSplits();
  return <div>{data && <OptionSplitsTable data={data} />}</div>;
}
